import React, { useState } from 'react';
import { PenTool, ChevronDown, ChevronUp, Sparkles } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const PracticeExercise = ({ number, title, instructions, prompts = [] }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="my-6 bg-gradient-to-br from-courtyard-parchment to-white border border-courtyard-gold/20 rounded-2xl shadow-sm overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-4 text-left p-5 hover:bg-courtyard-gold/5 transition-colors"
      >
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-courtyard-terracotta/20 to-courtyard-gold/20 flex items-center justify-center flex-shrink-0">
          <PenTool className="w-5 h-5 text-courtyard-clay" aria-hidden="true" />
        </div>
        <div className="flex-1">
          <p className="text-xs font-bold text-courtyard-clay uppercase tracking-wider">
            Exercise {number}
          </p>
          <p className="font-display font-bold text-courtyard-stone">{title}</p>
        </div>
        <div className="w-8 h-8 rounded-full bg-courtyard-stone/5 flex items-center justify-center">
          {expanded ? (
            <ChevronUp className="w-4 h-4 text-courtyard-stone/80" aria-hidden="true" />
          ) : (
            <ChevronDown className="w-4 h-4 text-courtyard-stone/80" aria-hidden="true" />
          )}
        </div>
      </button>

      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="overflow-hidden"
          >
            <div className="px-5 pb-5 pt-1 border-t border-courtyard-gold/10">
              {instructions && (
                <div className="flex gap-2 items-start mt-3 mb-4">
                  <Sparkles className="w-4 h-4 text-courtyard-gold mt-0.5 flex-shrink-0" aria-hidden="true" />
                  <p className="text-[15px] text-courtyard-stone/75 leading-relaxed">{instructions}</p>
                </div>
              )}
              {prompts.length > 0 && (
                <ul className="space-y-2.5 ml-6">
                  {prompts.map((prompt, i) => (
                    <li key={i} className="flex gap-3 text-[15px] text-courtyard-stone/80">
                      <span className="w-5 h-5 rounded-full bg-courtyard-gold/15 flex items-center justify-center flex-shrink-0 text-xs font-bold text-courtyard-gold mt-0.5">
                        {i + 1}
                      </span>
                      <span className="leading-relaxed">{prompt}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default PracticeExercise;
